import script from "./listRoadmap.vue?vue&type=script&setup=true&lang=js"
export * from "./listRoadmap.vue?vue&type=script&setup=true&lang=js"

import "./listRoadmap.vue?vue&type=style&index=0&id=9646bc8c&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9646bc8c"]])

export default __exports__